import { useQuery } from '@tanstack/react-query';
import { awaitJSON, SheetsLambdaFetch } from '@src/utils/fetch-utils';

const COMPANY_IDS_QUERY_KEY = ['companyIds'];

const fetchCompanyIds = async (): Promise<string[]> => {
  const res = await SheetsLambdaFetch('/get_company_ids');
  const { ids } = await awaitJSON<{ ids: string[] }>(res);
  return ids;
};

// Named useCompanyIds (not useCompanyOptions/useCompanyInfo) to dodge collisions with two other
// differently-shaped hooks already in the codebase. Uses a global query key so every caller shares
// one cache entry instead of each page re-fetching the same company list independently.
export const useCompanyIds = (): ReturnType<typeof useQuery<string[]>> =>
  useQuery({ queryKey: COMPANY_IDS_QUERY_KEY, queryFn: fetchCompanyIds });
